"use client";
import { jsx as n, jsxs as t } from "react/jsx-runtime";
import { Shadow as d, RootProvider as a, WebWidgetInteractionType as S, IntelligentForm as e, useIntelligentForm as l, LoadingIndicator as m } from "@inkeep/cxkit-styled";
function b(o) {
  const { baseSettings: r } = o;
  return /* @__PURE__ */ n(
    d,
    {
      wrapperStyles: {
        height: "inherit",
        width: "inherit"
      },
      children: /* @__PURE__ */ n(
        a,
        {
          config: {
            baseSettings: r
          },
          componentType: S.IntelligentForm,
          children: /* @__PURE__ */ n(h, { ...o })
        }
      )
    }
  );
}
function h(o) {
  const { formSettings: r } = o;
  return /* @__PURE__ */ n(e.Provider, { formSettings: r, children: /* @__PURE__ */ t(e.Root, { children: [
    /* @__PURE__ */ n(e.Heading, {}),
    /* @__PURE__ */ n(e.Content, { children: /* @__PURE__ */ t(e.ContentScrollArea, { children: [
      /* @__PURE__ */ t(e.ContentScrollAreaViewport, { children: [
        /* @__PURE__ */ n(p, {}),
        /* @__PURE__ */ n(f, {}),
        /* @__PURE__ */ n(g, {}),
        /* @__PURE__ */ n(F, {}),
        /* @__PURE__ */ n(I, {})
      ] }),
      /* @__PURE__ */ n(e.ContentScrollAreaScrollbar, { children: /* @__PURE__ */ n(e.ContentScrollAreaThumb, {}) }),
      /* @__PURE__ */ n(e.ContentScrollAreaCorner, {})
    ] }) })
  ] }) });
}
function p() {
  return /* @__PURE__ */ t(e.Success, { children: [
    /* @__PURE__ */ n(e.SuccessIcon, {}),
    /* @__PURE__ */ n(e.SuccessHeading, {}),
    /* @__PURE__ */ n(e.SuccessMessage, {})
  ] });
}
function f() {
  const { isSubmitSuccessful: o } = l();
  return o ? null : /* @__PURE__ */ t(e.PrimaryForm, { children: [
    /* @__PURE__ */ n(e.PrimaryFormDescription, {}),
    /* @__PURE__ */ n(e.PrimaryFormFields, { children: (r) => r.map((i) => /* @__PURE__ */ n(s, { field: i }, i.name)) }),
    /* @__PURE__ */ n(e.PrimaryFormSubmit, {})
  ] });
}
function u() {
  return /* @__PURE__ */ t(e.BotHeading, { children: [
    /* @__PURE__ */ n(e.BotHeadingIcon, {}),
    /* @__PURE__ */ n(e.BotHeadingName, {})
  ] });
}
function g() {
  return /* @__PURE__ */ t(e.Loading, { children: [
    /* @__PURE__ */ n(u, {}),
    /* @__PURE__ */ n(m, {})
  ] });
}
function F() {
  const { isSubmitSuccessful: o } = l();
  return o ? null : /* @__PURE__ */ t(e.ConfidentResponse, { children: [
    /* @__PURE__ */ n(u, {}),
    /* @__PURE__ */ t(e.Sources, { children: [
      /* @__PURE__ */ n(e.SourcesCaption, {}),
      /* @__PURE__ */ n(e.SourcesList, { children: (r) => r.map((i) => /* @__PURE__ */ t(e.Source, { source: i, children: [
        /* @__PURE__ */ n(e.SourceIcon, {}),
        /* @__PURE__ */ n(e.SourceTitle, {})
      ] }, i.url)) })
    ] }),
    /* @__PURE__ */ n(e.ConfidentAnswer, {}),
    /* @__PURE__ */ t(e.ConfidentResponseButton, { children: [
      /* @__PURE__ */ n(e.ConfidentResponseButtonIcon, {}),
      /* @__PURE__ */ n(e.ConfidentResponseButtonLabel, {})
    ] })
  ] });
}
function I() {
  const { aiResponse: o } = l(), { isSubmitSuccessful: r } = l();
  return r ? null : /* @__PURE__ */ t(e.SecondaryForm, { children: [
    /* @__PURE__ */ n(u, {}),
    !o.answerConfidence && /* @__PURE__ */ t(e.Sources, { children: [
      /* @__PURE__ */ n(e.SourcesCaption, { children: "I wasn't able to find a direct answer to your question, but here's some helpful sources:" }),
      /* @__PURE__ */ n(e.SourcesList, { children: (i) => i.map((c) => /* @__PURE__ */ t(e.Source, { source: c, children: [
        /* @__PURE__ */ n(e.SourceIcon, {}),
        /* @__PURE__ */ n(e.SourceTitle, {})
      ] }, c.url)) })
    ] }),
    /* @__PURE__ */ n(e.SecondaryFormDescription, {}),
    /* @__PURE__ */ n(e.SecondaryFormFields, { children: (i) => i.map((c) => /* @__PURE__ */ n(s, { field: c }, c.name)) }),
    /* @__PURE__ */ n(e.Error, {}),
    /* @__PURE__ */ n(e.SecondaryFormSubmit, {})
  ] });
}
function s(o) {
  const { field: r } = o;
  return /* @__PURE__ */ t(e.Field, { field: r, children: [
    /* @__PURE__ */ n(e.FieldLabel, {}),
    r.inputType === "text" && /* @__PURE__ */ n(e.Text, {}),
    r.inputType === "email" && /* @__PURE__ */ n(e.Email, {}),
    r.inputType === "file" && /* @__PURE__ */ n(e.File, {}),
    r.inputType === "textarea" && /* @__PURE__ */ n(e.TextArea, {}),
    r.inputType === "checkbox" && /* @__PURE__ */ n(e.Checkbox, { children: /* @__PURE__ */ n(e.CheckboxIndicator, {}) }),
    r.inputType === "select" && /* @__PURE__ */ t(e.Select, { children: [
      /* @__PURE__ */ t(e.SelectTrigger, { children: [
        /* @__PURE__ */ n(e.SelectValue, {}),
        /* @__PURE__ */ n(e.SelectIcon, {})
      ] }),
      /* @__PURE__ */ n(e.SelectContent, { children: /* @__PURE__ */ n(e.SelectViewport, { children: r.items.map((i) => /* @__PURE__ */ t(e.SelectItem, { value: i.value, children: [
        /* @__PURE__ */ n(e.SelectItemText, { children: i.label }),
        /* @__PURE__ */ n(e.SelectItemIndicator, {})
      ] }, i.value)) }) })
    ] }),
    /* @__PURE__ */ n(e.FieldError, {})
  ] }, r.name);
}
export {
  b as InkeepIntelligentForm,
  h as InkeepIntelligentFormImpl
};
